module.exports = __webpack_public_path__ + "media/success_scan.e43e76d7.mp3";